import { Controller } from "stimulus"

/**
 * Debounce throttles the given function to only execute once every wait
 * interval.
 */
 const debounce = (func, wait) => {
  let timeout

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait)
  }
}

export default class extends Controller {
  /**
   * Debounces the autocomplete event.
   *
   * See https://discuss.hotwire.dev/t/throttle-inside-a-controller/100/2.
   */
   static get targets() {
    return [
      "search",
      "input",
      "result"
    ]
  }

  initialize = () => {
    this.autocomplete = debounce(this.autocomplete, 35)
  }

  /**
   * preventDefault prevents a default event.
   */
  preventDefault(ev) {
    ev.preventDefault()
    return false
  }

  /**
   * autocomplete autocompletes results from an input field.
   */
  autocomplete = ev => {
    ev.preventDefault()

    const addr = this.inputTarget.value
    if (addr === "") {
      this.resultTarget.innerHTML = `<p class="mx-2">Start typing to see results</p>`;
      return
    }

    fetch("/address?q="+addr)
      .then(response => response.text())
      .then(result => { this.resultTarget.innerHTML = result })
      .catch(error => { this.resultTarget.innerHTML = `<p>Error: " ${error}</p>`})
  }
}
